import { render, staticRenderFns } from "./channelgoods.vue?vue&type=template&id=894bc588&scoped=true&"
import script from "./channelgoods.vue?vue&type=script&lang=js&"
export * from "./channelgoods.vue?vue&type=script&lang=js&"
import style0 from "./channelgoods.vue?vue&type=style&index=0&lang=css&"
import style1 from "./channelgoods.vue?vue&type=style&index=1&id=894bc588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894bc588",
  null
  
)

export default component.exports